const initialState = 0;

export default function NotificationReducer(state = initialState, action) {
    switch (action.type) {
        case 'PUT_NOTIFICATION':
            return action.count;
        case 'CLEAR_NOTIFICATION':
            return initialState;
        case 'DECREMENT_NOTIFICATION':
            return state - 1;
        default:
            return state;
    }
}